// extracted by mini-css-extract-plugin
module.exports = {"captcha":"styles__captcha___OB9af"};